import { render, staticRenderFns } from "./SnoozeViewer.vue?vue&type=template&id=135be2ad&"
import script from "./SnoozeViewer.vue?vue&type=script&lang=js&"
export * from "./SnoozeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports